import { useIntl } from 'react-intl';
import { Rule } from 'antd/lib/form';
import validatorPattern from '@/utils/validatorPattern';

const useDefaultOnlyLettersRule = (): Rule => {
  const intl = useIntl();

  return {
    pattern: /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
    validator: ({ pattern }, value) => {
      if (!value) return Promise.resolve();

      if (pattern && validatorPattern(pattern, String(value))) {
        return Promise.resolve();
      }
      return Promise.reject();
    },
    message: intl.formatMessage({
      id: 'commons.form.errors.invalidField',
    }),
  };
};

export default useDefaultOnlyLettersRule;
